import FrameBar from 'components/Widget/FrameBar';
import { shallowEqual, useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import BottomCenter from './BottomCenter';
import BottomLeft from './BottomLeft';
import TopRight from './TopRight';
import GuestCta from './GuestCta';

const Island = () => {
	const { centeredFrameId } = useSelector(
		(r: RootReducer) => ({
			centeredFrameId: r.mode.centeredFrameId,
		}),
		shallowEqual
	);

	const isFocusMode = centeredFrameId !== null;

	return (
		<>
			<TopRight />
			{isFocusMode ? (
				<FrameBar mode="focus" />
			) : (
				<>
					<BottomCenter />
					<BottomLeft />
				</>
			)}
			<GuestCta />
		</>
	);
};

export default Island;
